import { useEffect, useRef, useState } from 'react';
import Loading from '../../util/Loading';
import './ProductList.css';

const ProductList = ({fetchData, totalData, dataPerFetch, ItemComponent, GridComponent}) => {
  const [dataList, setDataList] = useState([]);
  const [needFetch, setNeedFetch] = useState(true);
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const page = useRef(0);

  console.log('dataList: ',dataList);

  console.log('totalData: ',totalData);
  
   // 스크롤 리스너 등록
   useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      const threshold = clientHeight / 2;
      if ((scrollTop + clientHeight >= scrollHeight - threshold) || scrollHeight <= clientHeight) {
        setNeedFetch(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // 최초 한 번만 등록

    useEffect(() => {
    const appendData = async () => {
      setLoading(true);
      const start = page.current * dataPerFetch;
      const end = start + dataPerFetch - 1 > totalData - 1 ? totalData - 1 : start + dataPerFetch - 1;
      let { data, error } = await fetchData(start, end);
      // console.log('데이터: ',data);
      
      if (!error) {
        setDataList(prev => [...prev, ...data]); //새로 추가된 데이터를 추가한다.
        setNeedFetch(false);
        page.current++;
      }
      setLoading(false);
      setInitialLoading(false);
    };
    if (needFetch && dataList.length < totalData) {
      appendData();
    }
  }, [needFetch, dataList.length, dataPerFetch, fetchData, totalData]); 

  
  if (initialLoading) {
    return <Loading message="Loading..." />;
  }

  return (
      <div className="product-list-container">
        <GridComponent>
          {dataList.map((item) => (<ItemComponent key={item.goods_seq} product={item} />))}
        </GridComponent>
        {loading && <Loading message="Loading..." />}
      </div>
  );
};

export default ProductList; 